import VNavigationDrawer from './VNavigationDrawer.vue';

export { VNavigationDrawer };
export default VNavigationDrawer;
